module.exports = __webpack_public_path__ + "static/img/18018C_3_R_20201105_fit.eca6378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18018C_3_R_20201105_fit.png
// module id = odK7
// module chunks = 0